export class Presentacion {
    codigoPresentacion: number;
    orden: number;
    descripcion: string;
}